






























import Vue from 'vue'
import Component from 'vue-class-component'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { NETWORK_STATUS_PAGE_INFORMATION } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-2-customer-website-page-information'

import NetworkResourceItem5NetworkPrivilegesSettings from './service-for-network-resource-item/network-resource-item-5-network-privileges-settings.vue'


@Component({
  components: {
    NetworkResourceItem5NetworkPrivilegesSettings
  }
})
class SettingsHelperComponents5NetworkResourceItem extends Vue {

  projectName: string = projectVariables.projectName
  digitalCurrencyName: string = projectVariables.digitalCurrencyName

  NETWORK_STATUS_PAGE_INFORMATION = NETWORK_STATUS_PAGE_INFORMATION

  // a list of the indexes of the panels that are open by default
  // [0, 2, 3, 1] means all 4 panels are expanded
  isExandedPanelList: number[] = []

  isOpenStatistics: number = 0
}

export default SettingsHelperComponents5NetworkResourceItem

